import { useAuthStore } from "@/store/auth.store";
import dayjs from "dayjs";
import { t } from "i18next";
import PlanStatusBadge from "./PlanStatusBadge";
import { PlanStatusActive } from "@/common/enums/enums";

export default function SubscriptionTopBar({
  shouldShowExpirationDate = true,
}: {
  shouldShowExpirationDate?: boolean;
}): JSX.Element {
  const { userData } = useAuthStore.getState();

  const getSubscriptionEndDate = (): string => {
    if (!userData?.periodEnd) {
      return t("settings.subscription.noSubscriptionAvailable");
    }
    const subscriptionEndDate = dayjs.unix(userData.periodEnd);
    if (userData?.periodEndCancel) {
      return `${t("settings.subscription.yourPlanWillExpire")} ${subscriptionEndDate.format("MMMM DD, YYYY")}`;
    } else {
      return `${t("settings.subscription.yourPlanWillRenew")} ${subscriptionEndDate.format("MMMM DD, YYYY")}`;
    }
  };

  return (
    <header className="bg-gradient-to-r bg-grey-100 rounded-b-[12px]">
      <div className="py-1 px-6">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mx-auto max-w-5xl md:px-6">
          <div className="flex flex-wrap items-center gap-3 py-1 my-2">
            <div className="flex items-center gap-2">
              <span className="font-bold">
                {t("settings.subscription.subscription")}
              </span>
              <span className="text-sm font-light">{userData?.planName}</span>
              <PlanStatusBadge
                status={userData?.planStatus || PlanStatusActive.CANCELLED}
              />
            </div>
          </div>
          {shouldShowExpirationDate && (
            <span className="text-sm bg-white/10 px-2 rounded-full">
              {getSubscriptionEndDate()}
            </span>
          )}
        </div>
      </div>
    </header>
  );
}
